<template>
  <div>
    <offer-goods-form
      :name_org-label="name_orgLabelComputed"
      :adress-label="adressLabelComputed"
      :email-label="emailLabelComputed"
      :phone-label="phoneLabelComputed"
      :request_type-label="request_typeLabelComputed"
      :change="false"
    />
    <div v-if="lang === 'ru'">
      <v-text-field
        v-if="name_orgLabelId"
        v-model="name_orgLabelRu"
        label="Наименование организации (русский)"
        outlined
      />
    </div>
    <div v-if="lang === 'en-US'">
      <v-text-field
        v-if="name_orgLabelId"
        v-model="name_orgLabelEng"
        label="Наименование организации (английский)"
        outlined
      />
    </div>
    <div v-if="lang === 'ru'">
      <v-text-field
        v-if="adressLabelId"
        v-model="adressLabelRu"
        label="Адрес (русский)"
        outlined
      />
    </div>
    <div v-if="lang === 'en-US'">
      <v-text-field
        v-if="adressLabelId"
        v-model="adressLabelEng"
        label="Адрес (английский)"
        outlined
      />
    </div>
    <div v-if="lang === 'ru'">
      <v-text-field
        v-if="emailLabelId"
        v-model="emailLabelRu"
        label="E-mail (русский)"
        outlined
      />
    </div>
    <div v-if="lang === 'en-US'">
      <v-text-field
        v-if="emailLabelId"
        v-model="emailLabelEng"
        label="E-mail (английский)"
        outlined
      />
    </div>
    <div v-if="lang === 'ru'">
      <v-text-field
        v-if="phoneLabelId"
        v-model="phoneLabelRu"
        label="Телефон (русский)"
        outlined
      />
    </div>
    <div v-if="lang === 'en-US'">
      <v-text-field
        v-if="phoneLabelId"
        v-model="phoneLabelEng"
        label="Телефон (английский)"
        outlined
      />
    </div>
    <div v-if="lang === 'ru'">
      <v-text-field
        v-if="request_typeLabelId"
        v-model="request_typeLabelRu"
        label="Тип заявки (русский)"
        outlined
      />
    </div>
    <div v-if="lang === 'en-US'">
      <v-text-field
        v-if="request_typeLabelId"
        v-model="request_typeLabelEng"
        label="Тип заявки (английский)"
        outlined
      />
    </div>
    <v-btn @click="saveChanges">Сохранить изменения</v-btn>
  </div>
</template>

<script>
import OfferGoodsForm from "@/components/ui/OfferGoodsForm.vue";

export default {
  name: "ChangeOfferGoodsForm",
  components: { OfferGoodsForm },
  data() {
    const content_to_change = this.$store.getters["contentChanges/content_to_change"] || {};
    const get = (key) => (content_to_change[key] ? content_to_change[key] : { value_rus: "", value_eng: "" });
    return {
      name_orgLabelRu: get("name_orgLabel").value_rus,
      adressLabelRu: get("adressLabel").value_rus,
      emailLabelRu: get("emailLabel").value_rus,
      phoneLabelRu: get("phoneLabel").value_rus,
      request_typeLabelRu: get("request_typeLabel").value_rus,
      name_orgLabelEng: get("name_orgLabel").value_eng,
      adressLabelEng: get("adressLabel").value_eng,
      emailLabelEng: get("emailLabel").value_eng,
      phoneLabelEng: get("phoneLabel").value_eng,
      request_typeLabelEng: get("request_typeLabel").value_eng,
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    name_orgLabelId() {
      const c = this.$store.getters["contentChanges/content_to_change"];
      return c && c.name_orgLabel && c.name_orgLabel.id_content;
    },
    adressLabelId() {
      const c = this.$store.getters["contentChanges/content_to_change"];
      return c && c.adressLabel && c.adressLabel.id_content;
    },
    emailLabelId() {
      const c = this.$store.getters["contentChanges/content_to_change"];
      return c && c.emailLabel && c.emailLabel.id_content;
    },
    phoneLabelId() {
      const c = this.$store.getters["contentChanges/content_to_change"];
      return c && c.phoneLabel && c.phoneLabel.id_content;
    },
    request_typeLabelId() {
      const c = this.$store.getters["contentChanges/content_to_change"];
      return c && c.request_typeLabel && c.request_typeLabel.id_content;
    },
    name_orgLabelComputed() {
      return this.lang === "ru" ? this.name_orgLabelRu : this.name_orgLabelEng;
    },
    adressLabelComputed() {
      return this.lang === "ru" ? this.adressLabelRu : this.adressLabelEng;
    },
    emailLabelComputed() {
      return this.lang === "ru" ? this.emailLabelRu : this.emailLabelEng;
    },
    phoneLabelComputed() {
      return this.lang === "ru" ? this.phoneLabelRu : this.phoneLabelEng;
    },
    request_typeLabelComputed() {
      return this.lang === "ru" ? this.request_typeLabelRu : this.request_typeLabelEng;
    },
  },
  methods: {
    saveChanges() {
      const valueList = [];
      if (this.name_orgLabelId) {
        valueList.push({
          value_rus: this.name_orgLabelRu === undefined ? "" : this.name_orgLabelRu,
          value_eng: this.name_orgLabelEng === undefined ? "" : this.name_orgLabelEng,
          id_content: this.name_orgLabelId,
        });
      }
      if (this.adressLabelId) {
        valueList.push({
          value_rus: this.adressLabelRu === undefined ? "" : this.adressLabelRu,
          value_eng: this.adressLabelEng === undefined ? "" : this.adressLabelEng,
          id_content: this.adressLabelId,
        });
      }
      if (this.emailLabelId) {
        valueList.push({
          value_rus: this.emailLabelRu === undefined ? "" : this.emailLabelRu,
          value_eng: this.emailLabelEng === undefined ? "" : this.emailLabelEng,
          id_content: this.emailLabelId,
        });
      }
      if (this.phoneLabelId) {
        valueList.push({
          value_rus: this.phoneLabelRu === undefined ? "" : this.phoneLabelRu,
          value_eng: this.phoneLabelEng === undefined ? "" : this.phoneLabelEng,
          id_content: this.phoneLabelId,
        });
      }
      if (this.request_typeLabelId) {
        valueList.push({
          value_rus: this.request_typeLabelRu === undefined ? "" : this.request_typeLabelRu,
          value_eng: this.request_typeLabelEng === undefined ? "" : this.request_typeLabelEng,
          id_content: this.request_typeLabelId,
        });
      }
      this.$store.dispatch("contentChanges/SAVE_CONTENT_CHANGES", { valueList });
    },
  },
};
</script>
